import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=05e5bb40&scoped=true&"
import script from "./CheckComponent.vue?vue&type=script&lang=js&"
export * from "./CheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckComponent.vue?vue&type=style&index=0&id=05e5bb40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5bb40",
  null
  
)

export default component.exports